import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "Millionare Mir Studio — Music Photography & Cinematic Film";
  }, []);

  return (
    <div className="App min-h-screen bg-[#050505] text-[#F5F5F0]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/work/:id" element={<CaseStudyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F5F5F0",
            borderRadius: "0px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
